import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
// client js begin
import { env } from '@tencent/vft-common';
// client js end
import { NormalModVisible } from '@/util/const';
export default {
  computed: {
    $_base_IsVip: function $_base_IsVip() {
      return this.$_base_IsNormalVip || this.$_base_IsVisitorVip;
    },
    $_base_IsSvip: function $_base_IsSvip() {
      return this.$store.state.svip && this.$store.state.svip.tv.vip;
    },
    $_base_IsVisitorVip: function $_base_IsVisitorVip() {
      return this.payVip && this.payVip.visitor && this.payVip.visitor.vip;
    },
    $_base_IsNormalVip: function $_base_IsNormalVip() {
      return this.payVip && this.payVip.vip;
    }
  },
  methods: {
    checkVipStatus: function () {
      var _checkVipStatus = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;
        var visible,
          _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                visible = _args.length > 0 && _args[0] !== undefined ? _args[0] : 1;
                if (!this.$_base_IsVisitorVip) {
                  _context.next = 4;
                  break;
                }
                this.confirm({
                  msg: '领取福利需将游客模式VIP服务转移至微信或者QQ账号',
                  confirmText: '转移',
                  confirm: function confirm() {
                    _this.openUrl('tenvideo2://?action=20');
                  }
                });
                return _context.abrupt("return", false);
              case 4:
                if (this.$store.state.isLogin) {
                  _context.next = 13;
                  break;
                }
                _context.next = 7;
                return this.$store.dispatch('checkLogin');
              case 7:
                if (!env.isApp) {
                  _context.next = 10;
                  break;
                }
                _context.next = 10;
                return this.$store.dispatch('checkLogin');
              case 10:
                if (this.$store.state.isLogin) {
                  _context.next = 13;
                  break;
                }
                this.confirm({
                  msg: '会员福利需登录微信或QQ账号后才能享受',
                  confirmText: '登录',
                  confirm: function confirm() {
                    _this.$openLogin();
                  }
                });
                return _context.abrupt("return", false);
              case 13:
                if (!(visible === NormalModVisible.HVip && !this.$_base_IsVip)) {
                  _context.next = 20;
                  break;
                }
                if (!env.isApp) {
                  _context.next = 17;
                  break;
                }
                _context.next = 17;
                return this.$store.dispatch('getPayVip');
              case 17:
                if (this.$_base_IsVip) {
                  _context.next = 20;
                  break;
                }
                this.confirm({
                  msg: '开通VIP后才能享受到VIP福利',
                  confirmText: '开通VIP',
                  confirm: function confirm() {
                    var ru = encodeURIComponent(location.href);
                    var url = env.isApp ? 'tenvideo2://?action=20&ru=' + ru : '//film.qq.com/h5/vip-center/?ru=' + ru;
                    _this.openUrl(url);
                  }
                });
                return _context.abrupt("return", false);
              case 20:
                if (!(visible === NormalModVisible.SVip && !this.$_base_IsSvip)) {
                  _context.next = 23;
                  break;
                }
                this.confirm({
                  msg: '开通SVIP后才能享受到SVIP福利',
                  confirmText: '开通SVIP',
                  confirm: function confirm() {
                    var ru = encodeURIComponent(location.href);
                    _this.openUrl('https://film.qq.com/weixin/h5/spay/?ptag=fuli.svippay&ru=' + ru);
                  }
                });
                return _context.abrupt("return", false);
              case 23:
                return _context.abrupt("return", true);
              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function checkVipStatus() {
        return _checkVipStatus.apply(this, arguments);
      }
      return checkVipStatus;
    }()
  }
};